import {
  GOOGLE_ANALYTICS_ID_STAGING,
  GOOGLE_TAG_MANAGER_ID_STAGING,
  META_PIXEL_ID,
} from '@env';
export const stagingConfig = {
  // Environment
  ENVIRONMENT: 'staging',

  // API URL - set EXPO_PUBLIC_API_URL at build time, or uses default
  API_URL:
    process.env.EXPO_PUBLIC_API_URL ||
    'https://coloursense.onrender.com/api/v1',

  // Feature flags - Staging settings
  MOCK_MODE: false,
  DEBUG_API: false, // Disable debug in staging
  ENABLE_ANALYTICS: true,
  ENABLE_CRASH_REPORTING: true,

  // Google Analytics (shared with development)
  GOOGLE_ANALYTICS_ID: GOOGLE_ANALYTICS_ID_STAGING,

  // Google Tag Manager
  GOOGLE_TAG_MANAGER_ID: GOOGLE_TAG_MANAGER_ID_STAGING,

  // Meta Pixel
  META_PIXEL_ID: META_PIXEL_ID,

  // Timeouts (in milliseconds) - longer for staging to handle network latency
  TIMEOUTS: {
    API_REQUEST: 30000, // 30 seconds
    IMAGE_UPLOAD: 60000, // 60 seconds
    FILE_DOWNLOAD: 45000, // 45 seconds
  },

  // Logging
  LOG_LEVEL: 'error', // Only show errors in staging
  SHOW_DEV_WARNINGS: false, // Hide warnings in staging

  // Cache settings
  CACHE_TIMEOUT: 300000, // 5 minutes

  // staging specific settings
  ENABLE_HOT_RELOAD: false,
  ENABLE_REDUX_DEVTOOLS: false,
  ENABLE_PERFORMANCE_MONITORING: true,

  // Security settings
  ALLOW_HTTP: false, // Only HTTPS in staging
  DISABLE_SSL_VERIFICATION: false,

  // Performance optimizations
  ENABLE_COMPRESSION: true,
  ENABLE_CACHING: true,
  PRELOAD_CRITICAL_RESOURCES: true,

  // httpOnly cookie auth (web only) - tokens not in localStorage; defaults true for staging
  USE_HTTPONLY_COOKIES:
    (process.env.EXPO_PUBLIC_USE_HTTPONLY_COOKIES ?? 'true').toLowerCase() ===
    'true',
};
